import { clamp } from './clamp';

/** Apply a 2D convolution kernel to ImageData */
export function applyKernel(source: ImageData, kernel: number[], kernelSize: number): ImageData {
  const { width, height, data: src } = source;
  const output = new ImageData(width, height);
  const dst = output.data;
  const half = Math.floor(kernelSize / 2);

  for (let y = 0; y < height; y++) {
    for (let x = 0; x < width; x++) {
      let r = 0, g = 0, b = 0;
      for (let ky = 0; ky < kernelSize; ky++) {
        for (let kx = 0; kx < kernelSize; kx++) {
          const sx = clamp(x + kx - half, 0, width - 1);
          const sy = clamp(y + ky - half, 0, height - 1);
          const si = (sy * width + sx) * 4;
          const weight = kernel[ky * kernelSize + kx];
          r += src[si] * weight;
          g += src[si + 1] * weight;
          b += src[si + 2] * weight;
        }
      }
      const di = (y * width + x) * 4;
      dst[di] = clamp(Math.round(r), 0, 255);
      dst[di + 1] = clamp(Math.round(g), 0, 255);
      dst[di + 2] = clamp(Math.round(b), 0, 255);
      dst[di + 3] = src[di + 3];
    }
  }
  return output;
}
